import { createRouter, createWebHistory } from 'vue-router'
import Main from './components/Main.vue';
import MainInvest from "./components/Investitions/MainInvest.vue";
import MainReinvest from "./components/Reinvestitions/MainReinvest.vue";
import MainManagement from "./components/Management/MainManagement.vue";
import MainOurProjects from "./components/OurProjects/MainOurProjects.vue";
import MainProfile from "./components/Profile/MainProfile.vue";
import MainHome from "@/components/Home/MainHome.vue";
import PersonalDocs from "./components/Other/PersonalDocs.vue";
import NotFound from "./components/Other/NotFound.vue";

const routes = [
    {
        path: '/',
        name: 'Main',
        component: Main
    },
    {
        path: '/investition',
        name: 'Insvestition',
        component: MainInvest
    },
    {
        path: '/reinvestition',
        name: 'Rensvestition',
        component: MainReinvest
    },
    {
        path: '/management',
        name: 'Management',
        component: MainManagement
    },
    {
        path: '/ourprojects',
        name: 'OurProjects',
        component: MainOurProjects
    },
    {
        path: '/profile',
        name: 'Profile',
        component: MainProfile
    },
    {
        path: '/home',
        name: 'MainHome',
        component: MainHome
    },
    {
        path: '/repair',
        name: 'MainRepair',
        component: MainHome
    },
    {
        path: '/docs/personal',
        name: 'Personal',
        component: PersonalDocs
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    },


]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.


export const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    routes, // short for `routes: routes`
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
                offset: { x: window.scrollX, y: 0 }  // сохраняем текущую позицию X
            };
        }
        return savedPosition || { x: window.scrollX, y: 0 };  // не сбрасываем X
    }
  })